import React from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { NumericFormat } from "react-number-format";
import MyDatePicker from "./MyDatePicker";

const MyFermeture = ({
  sortie_su = "",
  onSortieSuChange = () => {},
  sortie_go = "",
  onSortieGoChange = () => {},
  textValue = "",
  onTextChange = () => {},
  dateValue = "",
  onDateChange = () => {},
  verList = [],
  verValues = {},
  onVerChange = () => {},
  onSend = () => {},
  error = "",
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
  };

  // Validation: tous les champs de verList doivent être remplis
  const canSend =
    textValue && sortie_su && sortie_go && verList.every((k) => verValues[k]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      width="100%"
      onClick={handleClick}
    >
      {/* DATE */}
      <MyDatePicker value={dateValue} onChange={onDateChange} />

      {/* SORTIE SU */}
      <NumericFormat
        thousandSeparator=" "
        decimalScale={2}
        decimalSeparator=","
        allowedDecimalSeparators={[",", "."]}
        customInput={TextField}
        fullWidth
        size="small"
        id="sortie-su-input"
        variant="outlined"
        placeholder="SORTIE SU (L)"
        value={sortie_su}
        onValueChange={onSortieSuChange}
      />

      {/* SORTIE GO */}
      <NumericFormat
        thousandSeparator=" "
        decimalScale={2}
        decimalSeparator=","
        allowedDecimalSeparators={[",", "."]}
        customInput={TextField}
        fullWidth
        size="small"
        id="sortie-go-input"
        variant="outlined"
        placeholder="SORTIE GO (L)"
        value={sortie_go}
        onValueChange={onSortieGoChange}
      />

      {/* Champs dynamiques de versement */}
      {verList.map((key) => (
        <NumericFormat
          key={key}
          thousandSeparator=" "
          decimalScale={key.endsWith("USD") ? 2 : 0}
          decimalSeparator=","
          allowedDecimalSeparators={[",", "."]}
          customInput={TextField}
          fullWidth
          size="small"
          id={`ver-input-${key}`}
          variant="outlined"
          placeholder={key.replace("_", " ")}
          value={verValues[key] || ""}
          onValueChange={(values) => onVerChange(key, values.value)}
        />
      ))}

      <TextField
        fullWidth
        size="small"
        variant="outlined"
        placeholder="Votre Nom et Prénom"
        value={textValue}
        onChange={onTextChange}
        id="nom-prenom-input"
        name="nomPrenom"
      />

      {error && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          color="success"
          size="small"
          sx={{ width: 140 }}
          onClick={onSend}
          disabled={!canSend}
        >
          ENVOYER
        </Button>
      </Box>
    </Box>
  );
};

export default MyFermeture;
